import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import AudiometryChart from '../core/AudiometryChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "demo"
    }}>{`Demo`}</h1>
    <h2 {...{
      "id": "audiometry-chart-with-solid-line"
    }}>{`Audiometry chart with solid line`}</h2>
    <Playground __position={0} __code={'<div style={{ width: 600 }}>\n  <AudiometryChart\n    toolboxTooltip={{ saveAsImageWithTitle: \'save as image\' }}\n    title=\"left\"\n    symbolsSize={16}\n    colors={[\'red\', \'red\']}\n    grid={{ left: \'10%\' }}\n    data={[\n      [\n        {\n          result: 60,\n        },\n        {\n          result: 50,\n        },\n        {\n          result: 60,\n          boneResult: 50,\n          boneSymbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 70,\n          boneResult: 10,\n          boneSymbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          boneSymbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 55,\n          boneSymbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n        },\n        {\n          result: 10,\n        },\n      ],\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      AudiometryChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div style={{
        width: 600
      }}>
        <AudiometryChart toolboxTooltip={{
          saveAsImageWithTitle: 'save as image'
        }} title='left' symbolsSize={16} colors={['red', 'red']} grid={{
          left: "10%"
        }} data={[[{
          result: 60
        }, {
          result: 50
        }, {
          result: 60,
          boneResult: 50,
          boneSymbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 70,
          boneResult: 10,
          boneSymbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          boneSymbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 55,
          boneSymbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50
        }, {
          result: 10
        }]]} mdxType="AudiometryChart" />
    </div>
    </Playground>
    <h2 {...{
      "id": "audiometry-chart-with-dashed-line"
    }}>{`Audiometry chart with dashed line`}</h2>
    <Playground __position={1} __code={'<div style={{ width: 600 }}>\n  <AudiometryChart\n    title=\"right\"\n    color=\"blue\"\n    colors={[\'blue\']}\n    lineType=\"dashed\"\n    data={[\n      [\n        {\n          result: 60,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 60,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 70,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 55,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 10,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n      ],\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      AudiometryChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div style={{
        width: 600
      }}>
        <AudiometryChart title='right' color='blue' colors={['blue']} lineType='dashed' data={[[{
          result: 60,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 60,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 70,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 55,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 10,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }]]} mdxType="AudiometryChart" />
    </div>
    </Playground>
    <h2 {...{
      "id": "audiometry-chart-with-cuncurrent-lines"
    }}>{`Audiometry chart with cuncurrent lines`}</h2>
    <Playground __position={2} __code={'<div style={{ width: 600 }}>\n  <AudiometryChart\n    tooltipMarker\n    legendsPosition=\"bottom\"\n    legendGap={7}\n    grid={{ bottom: 80 }}\n    title=\"right\"\n    color=\"black\"\n    legends={[\n      {\n        name: \'mark\',\n        icon:\n          \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n      },\n      {\n        name: \'red\',\n        icon:\n          \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n      },\n      { name: \'blue\' },\n      { name: \'item-special-second\' },\n      { name: \'item-special-twelve\' },\n      { name: \'item-special-bing-bang\' },\n    ]}\n    colors={[\'red\', \'red\', \'blue\', \'green\', \'purple\', \'yellow\']}\n    data={[\n      [\n        {\n          result: 60,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n          boneResult: 10,\n          boneSymbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 60,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 70,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 55,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 50,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n        {\n          result: 10,\n          symbol:\n            \'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z\',\n        },\n      ],\n      [\n        {\n          result: 63,\n        },\n      ],\n      [\n        {\n          result: 71,\n        },\n      ],\n      [\n        {\n          result: 90,\n        },\n      ],\n      [\n        {\n          result: 51,\n        },\n      ],\n    ]}\n  />\n</div>'} __scope={{
      props,
      DefaultLayout,
      AudiometryChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <div style={{
        width: 600
      }}>
        <AudiometryChart tooltipMarker legendsPosition="bottom" legendGap={7} grid={{
          bottom: 80
        }} title='right' color='black' legends={[{
          name: 'mark',
          icon: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          name: 'red',
          icon: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          name: 'blue'
        }, {
          name: 'item-special-second'
        }, {
          name: 'item-special-twelve'
        }, {
          name: 'item-special-bing-bang'
        }]} colors={['red', 'red', 'blue', 'green', 'purple', 'yellow']} data={[[{
          result: 60,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z',
          boneResult: 10,
          boneSymbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 60,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 70,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 55,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 50,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }, {
          result: 10,
          symbol: 'path://M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
        }], [{
          result: 63
        }], [{
          result: 71
        }], [{
          result: 90
        }], [{
          result: 51
        }]]} mdxType="AudiometryChart" />
    </div>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      